import {
  Get_CustomerDefaultAddress,
  Get_CustomerName,
  Get_PhoneNo,
} from "../../../../database/get-stored-data";
import AfterSigninpng from "./AfterSigninpng.png";
import React from "react";
import "../../../../styles/css/pg-profile-header-section.css";

export default class HeaderSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      CustomerName: "",
      PhoneNumber: "",
      DefaultAddress: "",
    };
  }
  async componentDidMount() {
    this.setState({
      CustomerName: await Get_CustomerName(),
      PhoneNumber: await Get_PhoneNo(),
      DefaultAddress: await Get_CustomerDefaultAddress(),
    });
  }
  render() {
    let CSID = this.props.CSID;
    // if (CSP === "MK" || CSP === "DT") {
      return (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            paddingBottom: "40px",
          }}
        >
          <h2
            style={{
              marginTop: "10px",
              marginLeft: "15px",
              fontWeight: "bold",
            }}
          >
            {CSID !== 0 ? this.state.CustomerName : "Welcome"}
          </h2>
          <div className="pgProfileLG">
            <img src={AfterSigninpng} alt="Login Profile" />
          </div>
        </div>
      );
    // } else {
    //   return (
    //     <div
    //       className="pgProfileBG fadeInDown animated"
    //       style={{ backgroundColor: Colors.ThemeBGcolor }}
    //     >
    //       <div
    //         className="pgProfile"
    //         onClick={() => {
    //           if (CSID === 0) {
    //             this.props.navigate(PT_SIGNIN);
    //           }
    //         }}
    //         style={{ cursor: CSID === 0 ? "pointer" : "default" }}
    //       >
    //         { CSID !== 0 ? (
    //           <img src={AfterSigninpng} alt="Login Profile" />
    //         ) : (
    //           <img src={BeforeSignin} alt="Login Profile" />
    //         )}
    //       </div>
    //       {CSID !== 0 ? (
    //         <div
    //           style={{
    //             justifyContent: "center",
    //             alignItems: "center",
    //             color: "white",
    //             textAlign: "center",
    //             marginTop: "8px",
    //           }}
    //         >
    //           <h1 id="pg-profile-header-section-font">
    //             Welcome Back {this.state.CustomerName}
    //           </h1>
    //           <h1
    //             style={{ marginTop: "4px" }}
    //             id="pg-profile-header-section-font"
    //           >
    //             {this.state.PhoneNumber}
    //           </h1>
    //           <p style={{ fontSize: Font.SmallDescription, marginTop: "5px" }}>
    //             {CONCAT_TEXT_LIMIT({
    //               length: 60,
    //               string: this.state.DefaultAddress,
    //             })}
    //             {/* {this.state.DefaultAddress} */}
    //           </p>
    //         </div>
    //       ) : (
    //         <div
    //           style={{
    //             justifyContent: "center",
    //             alignItems: "center",
    //             color: "white",
    //             textAlign: "center",
    //             marginTop: "2px",
    //           }}
    //         >
    //           Sign In
    //         </div>
    //       )}
    //     </div>
    //   );
    // }
  }
}
